<template>
  <div>
    <nav class="bottom-nav">
      <div
        v-for="nav in data.navs"
        :key="nav.label"
        class="cursor-pointer"
        @click="handleRedirect(nav.to)"
      >
        <div
          class="flex flex-col items-center"
          :class="{ 'big-button': nav.isButton }"
        >
          <img
            class="w-6 h-6"
            :src="isActiveNav(nav.to!.name) ?nav.imageActive :nav.imageInactive"
          />
          <a
            href="#"
            class="mt-1 mid-text-caption-1"
            :class="{'text-primary font-semibold':isActiveNav(nav.to!.name)}"
            >{{ nav.label }}
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import HomeActive from './assets/home-active.png'
import HomeInactive from './assets/home-inactive.png'
import ExploreActive from './assets/explore-active.png'
import ExploreInactive from './assets/explore-inactive.png'
import ActivityActive from './assets/activity-active.png'
import ActivityInactive from './assets/activity-inactive.png'
import HelpActive from './assets/help-active.png'
import HelpInactive from './assets/help-inactive.png'
import Charge from './assets/charge.png'

const router = useRouter()
const route = useRoute()

const data = reactive({
  navs: [
    {
      imageActive: HomeActive,
      imageInactive: HomeInactive,
      label: 'Beranda',
      to: {
        name: 'home'
      }
    },
    {
      imageActive: ExploreActive,
      imageInactive: ExploreInactive,
      label: 'Lokasi',
      to: {
        name: 'explore'
      }
    },
    {
      isButton: true,
      imageActive: Charge,
      imageInactive: Charge,
      label: 'Charge',
      to: {
        name: 'scan-qr'
      }
    },
    {
      imageActive: ActivityActive,
      imageInactive: ActivityInactive,
      label: 'Transaksi',
      to: {
        name: 'activity'
      }
    },
    {
      imageActive: HelpActive,
      imageInactive: HelpInactive,
      label: 'Bantuan',
      to: {
        name: 'help'
      }
    }
  ]
})

const handleRedirect = (to: any) => {
  if (to) {
    router.push(to)
  }
}

const isActiveNav = (routeName: string) => {
  if (route.name === routeName) {
    return true
  } else {
    return false
  }
}
</script>

<style lang="scss">
@import 'tailwindcss' reference;

.bottom-nav {
  @apply fixed bottom-0 left-0 right-0 py-2 px-5 flex justify-between mx-auto bg-white;
  color: var(--color-black-300);
  max-width: 480px;
  height: 64px;
  box-shadow: 0 -4px 10px -1px rgba(0, 0, 0, 0.1);

  .big-button {
    @apply text-white flex flex-col items-center;
    background-color: var(--color-primary);
    margin-top: -20px;
    padding-top: 12px;
    border-radius: 64px;
    width: 64px;
    height: 64px;
  }
}
</style>
